import { differenceInDays } from 'date-fns';
import { useState } from 'react';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { ConditionalWrapper } from '#src/atoms/layout/ConditionalWrapper/index.tsx';

import { SetEndCountdownChip } from '../SetEndCountdownChip/index.tsx';
import { SetWillEndDialog } from '../SetWillEndDialog/index.tsx';

type Props = { endDate: Date };
export const SeriesBoardTimer = ({ endDate }: Props) => {
  const [showDialog, setShowDialog] = useState(false);

  const lessThan7Days = differenceInDays(endDate, new Date()) <= 7;

  return (
    <>
      <ConditionalWrapper
        Wrapper={ButtonBase}
        wrap={lessThan7Days}
        props={{
          onClick: () => {
            setShowDialog(true);
          },
        }}
      >
        <SetEndCountdownChip endDate={endDate} />
      </ConditionalWrapper>
      <SetWillEndDialog
        open={!!showDialog}
        onClose={() => {
          setShowDialog(false);
        }}
        endDate={endDate}
      />
    </>
  );
};
